import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }

import { ref, defineAsyncComponent } from 'vue'
import { VueDraggableNext } from 'vue-draggable-next'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexDraggable',
  setup(__props) {

const draggable = VueDraggableNext
const draggableCard = defineAsyncComponent(() => import("@/components/theme/advance/draggable/draggableCard.vue"))
const shadowCard = defineAsyncComponent(() => import("@/components/theme/advance/draggable/shadowCard.vue"))
const iconCard = defineAsyncComponent(() => import("@/components/theme/advance/draggable/iconCard.vue"))
const checboxCard = defineAsyncComponent(() => import("@/components/theme/advance/draggable/checboxCard.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Bonus Ui",
      title: "Draggable Card"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(draggable), { class: "row" }, {
        default: _withCtx(() => [
          _createVNode(_unref(draggableCard)),
          _createVNode(_unref(shadowCard)),
          _createVNode(_unref(iconCard)),
          _createVNode(_unref(checboxCard))
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})